$(function () {
  'use strict';

  const $numberFields = $('.js-number-validation');
  const $form = $numberFields.closest('form');
  const VALIDATION_TYPES = {
    MIN: 'min',
    MAX: 'max',
    INTEGER: 'integer',
    REQUIRED: 'required'
  };
  const VALIDATION_MESSAGES = {
    integer: {
      belowInput: '整数を入力してください',
      alert: (name) => `${name}は整数を入力してください。`
    },
    required: {
      belowInput: (name) => `${name}を入力してください`,
      alert: (name) => `${name}を入力してください。`
    },
    min: {
      belowInput: (min) => `${formatNumber(min)}以上の値で記入してください`,
      alert: (name, min) => `${name}は${formatNumber(min)}以上の値で記入してください。`
    },
    max: {
      belowInput: (max) => `${formatNumber(max)}以下の値で記入してください`,
      alert: (name, max) => `${name}は${formatNumber(max)}以下の値で記入してください。`
    },
    minMax: {
      belowInput: (min, max) => `${formatNumber(min)}〜${formatNumber(max)}の間で記入してください`,
      alert: (name, min, max) => `${name}は${formatNumber(min)}〜${formatNumber(max)}の間で記入してください。`
    }
  };

  class ValidationMessage {
    constructor(messageBelowInput, messageAlert) {
      this.messageBelowInput = messageBelowInput;
      this.messageAlert = messageAlert;
    }
  }

  function enableButtons(submitButtonName) {
    $form.find('input[type=submit]').prop('disabled', false);
    $('.js-submittable').val(submitButtonName);
  }
  function showErrorMessage(field, validationMessage, isDisplayAlert = false) {
    const $caution = $(field).siblings('.number-helper-text');

    $caution.addClass('is-error');
    field.classList.add('is-error');

    if (validationMessage) {
      $caution.text(validationMessage.messageBelowInput);

      if (isDisplayAlert) {
        toastr.error(validationMessage.messageAlert);
      }
    }
  }
  function hideErrorMessage(field) {
    const $caution = $(field).siblings('.number-helper-text');

    $caution.removeClass('is-error');
    field.classList.remove('is-error');
    $caution.text(field.dataset.caution ? field.dataset.caution : '');
  }
  function generateErrorMessage(type, field) {
    const name = field.dataset.name;

    switch (type) {
      case VALIDATION_TYPES.MIN:
        return generateMinMaxErrorMessage(name, field, true);
      case VALIDATION_TYPES.MAX:
        return generateMinMaxErrorMessage(name, field, false);
      case VALIDATION_TYPES.INTEGER:
        const integerMsg = VALIDATION_MESSAGES.integer;

        return new ValidationMessage(
          integerMsg.belowInput,
          integerMsg.alert(name)
        );
      case VALIDATION_TYPES.REQUIRED:
        const requiredMsg = VALIDATION_MESSAGES.required;

        return new ValidationMessage(
          requiredMsg.belowInput(name),
          requiredMsg.alert(name)
        );
      default:
        return new ValidationMessage('', '');
    }
  }
  function generateMinMaxErrorMessage(name, field, isCompareMin) {
    const fieldMin = parseFloat(field.min);
    const fieldMax = parseFloat(field.max);
    const minSet = field.dataset.minSet === 'true';
    const maxSet = field.dataset.maxSet === 'true';

    if (minSet && maxSet) {
      const minMaxMsg = VALIDATION_MESSAGES.minMax;

      return new ValidationMessage(
        minMaxMsg.belowInput(fieldMin, fieldMax),
        minMaxMsg.alert(name, fieldMin, fieldMax)
      );
    }

    if (isCompareMin) {
      const minMsg = VALIDATION_MESSAGES.min;

      return new ValidationMessage(
        minMsg.belowInput(fieldMin),
        minMsg.alert(name, fieldMin)
      );
    } else {
      const maxMsg = VALIDATION_MESSAGES.max;

      return new ValidationMessage(
        maxMsg.belowInput(fieldMax),
        maxMsg.alert(name, fieldMax)
      );
    }
  }
  function formatNumber(number) {
    return Number(number).toLocaleString('ja-JP');
  }
  function validateNumberField($field, isDraft = true, isDisplayAlert = false) {
    const value = $field.val();
    const field = $field.get(0);

    hideErrorMessage(field);

    if (value === '') {
      if (!isDraft && field.dataset.required === 'true') {
        const validationMessage = generateErrorMessage(VALIDATION_TYPES.REQUIRED, field);

        showErrorMessage(field, validationMessage, isDisplayAlert);
        return false;
      } else {
        return true;
      }
    }

    return performValidations($field, isDisplayAlert);
  }
  function performValidations($field, isDisplayAlert = false) {
    const field = $field.get(0);
    const value = $field.val();
    const numValue = parseFloat(value);
    const minValue = parseFloat(field.min);
    const maxValue = parseFloat(field.max);

    if (numValue < minValue) {
      const validationMessage = generateErrorMessage(VALIDATION_TYPES.MIN, field);

      showErrorMessage(field, validationMessage, isDisplayAlert);
      return false;
    }
    if (numValue > maxValue) {
      const validationMessage = generateErrorMessage(VALIDATION_TYPES.MAX, field);

      showErrorMessage(field, validationMessage, isDisplayAlert);
      return false;
    }
    if (field.step === '1' && !Number.isInteger(numValue)) {
      const validationMessage = generateErrorMessage(VALIDATION_TYPES.INTEGER, field);

      showErrorMessage(field, validationMessage, isDisplayAlert);
      return false;
    }

    return true;
  }

  // ブラウザのデフォルトバリデーションを防ぐ
  $numberFields.on('invalid', function (e) {
    e.preventDefault();
    validateNumberField($(this), false, true);
  });

  // 入力時のバリデーション
  $numberFields.on('input blur', function () {
    validateNumberField($(this));
  });

  // フォーム送信時のバリデーション
  $form.on('submit', function (e) {
    let isValid = true;
    const $submitButton = $(document.activeElement);
    const submitButtonName = $submitButton.val();
    const isDraft = !$submitButton.attr('data-cy') || $submitButton.attr('data-cy') !== 'report-submit-button';

    $numberFields.each(function () {
      if (!validateNumberField($(this), isDraft, true)) {
        isValid = false;
      }
    });

    if (!isValid) {
      e.preventDefault();
      setTimeout(function () {
        enableButtons(submitButtonName);
      }, 500);
    }
  });
});
